import classNames from 'classnames'
import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import Input from '../Input'

export default function GoalsStep({ onSubmit }) {
  let [data, setData] = useState({
    goal1: '',
    goal2: '',
    goal3: ''
  })

  let valid = data.goal1 && data.goal2 && data.goal3

  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      <Card withGradient>

        <div className='px-24 py-12 flex text-white gap-36 items-center'>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
              Was möchtest du dieses Jahr erreichen?
            </div>
            <div className='text-neutral-500 text-lg'>
              Setze dir 3 Ziele für dein Business. Wir halten dich accountable.
            </div>
            <Button
              variant='secondary'
              className='text-primary'
              disabled={!valid}
              onClick={() => valid &&onSubmit(data)}
            >
              <strong className={classNames('px-12 font-bold', valid && 'text-primary')}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-6'>
            <Input
              title='Dein 1.Ziel'
              value={data.goal1}
              onChange={(e) => setData({ ...data, goal1: e.target.value })}
            />
            <Input
              title='Dein 2.Ziel'
              value={data.goal2}
              onChange={(e) => setData({ ...data, goal2: e.target.value })}
            />
            <Input
              title='Dein 3.Ziel'
              value={data.goal3}
              onChange={(e) => setData({ ...data, goal3: e.target.value })}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
